<app-confirm-match
  [courtReservation]="courtReservation"
  [yourMatchComponent]="true"
></app-confirm-match>
